import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Params, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { INavigationEnvironment } from '../interfaces/environment/navigation/navigation-environment.interface';
import { IAuthService, IAuthServiceToken } from '../services/infrastructure/authentication/auth-service.interface';
import { ServiceLocator } from '../services/infrastructure/service-locator.service';
import { IConfigurationServiceToken } from '../services/infrastructure/configuration/configuration-service.interface';

@Injectable({
  providedIn: 'root'
})
export class AnonymousGuard {
  private authenticated: boolean = false;
  private authorizedLandingPage: INavigationEnvironment;
  private authenticationSubscription: Subscription | undefined;
  private readonly authService: IAuthService = inject(IAuthServiceToken);

  constructor(
    private router: Router,
  ) {
    this.authorizedLandingPage = ENVIRONMENT.authorizedLandingPage;
    ServiceLocator.injector.get(IConfigurationServiceToken).authorizedLandingPageGet().subscribe((targetPage) => {
      this.authorizedLandingPage.routerlink = targetPage.routerlink as string;
      let queryParams = new URLSearchParams(targetPage.queryParams);
      let queryParamsObject: Params = {};
      queryParams.forEach((value, key) => {
        queryParamsObject[key] = value;
      });
      this.authorizedLandingPage.queryParams = queryParamsObject;
    });

    this.authenticated = this.authService.isAuthenticated();

    if (!this.authenticationSubscription) {
      this.authenticationSubscription = this.authService.authenticatedGet().subscribe(
        (authenticated) => {
          this.authenticated = authenticated;
        }
      );
    }

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authenticated) {
      let currentRoute = state.url;

      let authorizedLandingRouteArray = (typeof this.authorizedLandingPage.routerlink === 'string') ? [this.authorizedLandingPage.routerlink] : this.authorizedLandingPage.routerlink;
      let authorizedLandingRoute = authorizedLandingRouteArray.join('/');

      let shouldRedirect = currentRoute.localeCompare(authorizedLandingRoute) != 0;

      if (shouldRedirect) {
        this.router.navigate([this.authorizedLandingPage.routerlink], { queryParams: this.authorizedLandingPage.queryParams });
      }

      return false;
    }
    return true;
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authenticated) {
      this.router.navigate([this.authorizedLandingPage.routerlink], { queryParams: this.authorizedLandingPage.queryParams });
      return false;
    }
    return true;
  }
}
